import { render, staticRenderFns } from "./SymptomLabel.vue?vue&type=template&id=8758a014&scoped=true"
import script from "./SymptomLabel.vue?vue&type=script&lang=js"
export * from "./SymptomLabel.vue?vue&type=script&lang=js"
import style0 from "./SymptomLabel.vue?vue&type=style&index=0&id=8758a014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8758a014",
  null
  
)

export default component.exports